import { Box, Container } from "@mui/system"
import { Typography } from "@mui/material";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import HeaderLink from "./HeaderLink";

const Header = () => {
    return (
        <Box borderBottom={"1px solid gray"}>
            <Container>
                <Box display={"flex"} alignItems={"center"} height={"64px"} >
                    {/* LEFT growing */}
                    <Box display={"flex"} gap={6} alignContent={"center"} sx={{ flexGrow: 1 }}>
                        <HeaderLink to="/" main>EVK Vault Manager</HeaderLink>

                        <Box display={"flex"} gap={2} justifyContent={"center"}>
                            <HeaderLink to={"/vault"}>Vault</HeaderLink>
                            <HeaderLink to={"/oracle"}>Oracle Router</HeaderLink>
                            <Typography
                                component="a"
                                href="https://oracle-deployer.euler.finance/oracles"
                                target="_blank"
                                rel="noopener noreferrer"
                                fontWeight="normal"
                                fontSize="1.1em"
                                sx={{
                                    lineHeight: "2rem",
                                    color: "inherit",
                                    textDecoration: "inherit",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }}
                            >
                                Oracle Adapter
                            </Typography>
                            <HeaderLink to={"/configure-irm"}>IRM</HeaderLink>
                            <HeaderLink to={"/address-book"}>Address Book</HeaderLink>
                        </Box>
                    </Box>
                    <Box>
                        <ConnectButton />
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default Header
